export default "__VITE_ASSET__kj0Kgxur__"